/* ===== PartFay Theme JS =====
   لا يُحمَّل أي سكربت خارجي من الثيم. كل الطلبات تذهب لمسارات Shopify فقط. */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var cfg = window.PF_CONFIG || {};
  var T = cfg.t || {};

  function t(key, fallback) { return T[key] || fallback || ''; }

  /* ---------- أمان: قبول روابط داخلية/CDN فقط قبل وضعها في DOM ---------- */
  function safeUrl(u) {
    if (!u) return '';
    var s = String(u).trim();
    if (/^(https?:)?\/\//i.test(s) || s.charAt(0) === '/') return s;
    return '';
  }

  /* ---------- قفل التمرير: عدّاد حتى لا يفكّه إغلاق طبقة واحدة ---------- */
  var lockCount = 0;
  function lockScroll() { lockCount++; document.body.style.overflow = 'hidden'; }
  function unlockScroll() { lockCount = Math.max(0, lockCount - 1); if (!lockCount) document.body.style.overflow = ''; }

  /* ---------- تنفيذ fn بعد اكتمال حركة إغلاق العنصر (transform) فعليًا،
     بدل تخمين وقت ثابت — يمنع قفزة الصفحة (فكّ قفل التمرير/إرجاع التركيز)
     أثناء ما درج/طبقة لسا يتحركون بصريًا. مهلة احتياطية fallbackMs تحسبًا
     لعدم إطلاق transitionend (مثلاً لو العنصر أُزيل من الشجرة). ---------- */
  function afterClose(el, fallbackMs, fn) {
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      el.removeEventListener('transitionend', onEnd);
      fn();
    }
    function onEnd(e) {
      if (e.target !== el || e.propertyName !== 'transform') return;
      finish();
    }
    el.addEventListener('transitionend', onEnd);
    setTimeout(finish, fallbackMs);
  }

  /* ---------- حصر التركيز داخل الطبقات المنبثقة ---------- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function trapFocus(container) {
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var items = $$(FOCUSABLE, container).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    return function () { container.removeEventListener('keydown', onKey); };
  }

  /* ---------- التنبيهات ---------- */
  var toastBox;
  function toast(message, kind) {
    if (!message) return;
    if (!toastBox) {
      toastBox = document.createElement('div');
      toastBox.className = 'pf-toasts';
      toastBox.setAttribute('role', 'status');
      toastBox.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastBox);
    }
    var el = document.createElement('div');
    el.className = 'pf-toast' + (kind === 'error' ? ' pf-toast--err' : '');
    var ic = document.createElement('span');
    ic.className = 'pf-toast__ic';
    ic.innerHTML = kind === 'error'
      ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/><path d="M12 7v6M12 16.5v.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
      : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/><path d="M8 12.5l2.5 2.5L16 9.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var tx = document.createElement('span');
    tx.textContent = message;               // نص فقط — لا حقن HTML
    var x = document.createElement('button');
    x.type = 'button'; x.className = 'pf-toast__x';
    x.setAttribute('aria-label', t('close', 'إغلاق'));
    x.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
    el.appendChild(ic); el.appendChild(tx); el.appendChild(x);
    toastBox.appendChild(el);
    var timer = setTimeout(remove, 4200);
    function remove() { clearTimeout(timer); el.classList.add('is-out'); setTimeout(function () { el.remove(); }, 250); }
    x.addEventListener('click', remove);
  }
  window.pfToast = toast;

  /* ---------- عدّاد السلة ---------- */
  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  function getCart() {
    return fetch(cfg.routes ? cfg.routes.cart + '.js' : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* ---------- درج السلة الجانبي ---------- */
  var CartDrawer = (function () {
    var root, overlay, body, foot, releaseTrap, lastFocus;

    function el() { root = root || $('#pf-cart-drawer'); return root; }

    function open() {
      if (!el()) { window.location.href = cfg.routes ? cfg.routes.cart : '/cart'; return; }
      overlay = overlay || $('#pf-cd-overlay');
      lastFocus = document.activeElement;
      root.setAttribute('open', '');
      root.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.setAttribute('open', '');
      lockScroll();
      releaseTrap = trapFocus(root);
      var close = $('[data-cd-close]', root);
      if (close) setTimeout(function () { close.focus({ preventScroll: true }); }, 80);
    }

    function close() {
      if (!el() || !root.hasAttribute('open')) return;
      root.removeAttribute('open');
      root.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.removeAttribute('open');
      if (releaseTrap) { releaseTrap(); releaseTrap = null; }
      var toFocus = lastFocus;
      lastFocus = null;
      afterClose(root, 360, function () {
        unlockScroll();
        if (toFocus && toFocus.focus) toFocus.focus({ preventScroll: true });
      });
    }

    /* إعادة رسم محتوى الدرج من section HTML جاهز (مُرفق أصلاً برد /cart/add.js أو /cart/change.js)
       — يغني عن أي طلب شبكة إضافي، وهذا ما يجعل الإضافة والتعديل يحسّان فوريين. */
    function renderFromSections(sections) {
      if (!el() || !sections || !sections[cfg.cartDrawerSection]) return false;
      var doc = new DOMParser().parseFromString(sections[cfg.cartDrawerSection], 'text/html');
      var fresh = doc.querySelector('#pf-cart-drawer');
      if (!fresh) return false;
      var b = $('.pf-cd__body', root), f = $('.pf-cd__foot', root);
      var nb = fresh.querySelector('.pf-cd__body'), nf = fresh.querySelector('.pf-cd__foot');
      if (b && nb) b.innerHTML = nb.innerHTML;
      if (f && nf) f.innerHTML = nf.innerHTML;
      var count = fresh.getAttribute('data-count');
      if (count !== null) setCartCount(parseInt(count, 10) || 0);
      return true;
    }

    /* إعادة رسم محتوى الدرج عبر Section Rendering API — احتياطي فقط عند عدم توفر sections جاهزة */
    function refresh() {
      if (!el() || !cfg.cartDrawerSection) return getCart().then(function (c) { setCartCount(c.item_count); });
      root.classList.add('is-busy');
      return fetch(cfg.routes.cart + '?section_id=' + cfg.cartDrawerSection, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#pf-cart-drawer');
          if (!fresh) return;
          body = $('.pf-cd__body', root); foot = $('.pf-cd__foot', root);
          var nb = fresh.querySelector('.pf-cd__body'), nf = fresh.querySelector('.pf-cd__foot');
          if (body && nb) body.innerHTML = nb.innerHTML;
          if (foot && nf) foot.innerHTML = nf.innerHTML;
          var count = fresh.getAttribute('data-count');
          if (count !== null) setCartCount(parseInt(count, 10) || 0);
        })
        .catch(function () { return getCart().then(function (c) { setCartCount(c.item_count); }); })
        .then(function () { root.classList.remove('is-busy'); });
    }

    return { open: open, close: close, refresh: refresh, renderFromSections: renderFromSections, node: el };
  })();

  function initCartDrawer() {
    var root = CartDrawer.node();
    var overlay = $('#pf-cd-overlay');
    $$('[data-cd-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (!root) return;                 // بدون درج: الرابط يعمل طبيعيًا نحو /cart
        e.preventDefault();
        CartDrawer.open();
      });
    });
    if (!root) return;
    $$('[data-cd-close]', root).forEach(function (b) { b.addEventListener('click', CartDrawer.close); });
    if (overlay) overlay.addEventListener('click', CartDrawer.close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.hasAttribute('open')) CartDrawer.close();
    });
  }

  /* ---------- تعديل أسطر السلة (درج + صفحة السلة) ---------- */
  function changeLine(key, quantity, opts) {
    opts = opts || {};
    var payload = { id: key, quantity: quantity };
    if (cfg.cartDrawerSection) payload.sections = cfg.cartDrawerSection;
    return fetch((cfg.routes ? cfg.routes.cartChange : '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || t('cart_error', 'تعذّر تحديث السلة')); });
        return r.json();
      })
      .then(function (cart) {
        setCartCount(cart.item_count);
        if (opts.reload) { window.location.reload(); return cart; }
        // الرد يحوي HTML الدرج جاهزًا — نعرضه مباشرة بلا طلب شبكة إضافي
        if (!CartDrawer.renderFromSections(cart.sections)) CartDrawer.refresh();
        return cart;
      })
      .catch(function (err) { toast(err.message, 'error'); });
  }

  function initCartLines() {
    // تغيير الكمية داخل الدرج
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line-qty]');
      if (!b) return;
      e.preventDefault();
      var key = b.getAttribute('data-key');
      var qty = parseInt(b.getAttribute('data-qty'), 10);
      if (!key || isNaN(qty)) return;
      b.disabled = true;
      changeLine(key, Math.max(0, qty));
    });

    // حذف سطر
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cart-remove]');
      if (!b) return;
      e.preventDefault();
      var onCartPage = !!b.closest('.pf-cart__items');
      b.disabled = true;
      changeLine(b.getAttribute('data-key'), 0, { reload: onCartPage });
    });

    // حقل الكمية في صفحة السلة
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.matches || !input.matches('[data-cart-qty]')) return;
      var q = parseInt(input.value, 10);
      if (isNaN(q) || q < 0) q = 0;
      changeLine(input.getAttribute('data-key'), q, { reload: true });
    });
  }

  /* ---------- إضافة للسلة ---------- */
  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('[data-add-form]')) return;
      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      var isIcon = btn && btn.classList.contains('pf-card__add');
      if (btn) {
        btn.disabled = true;
        if (!isIcon) btn.textContent = btn.dataset.adding || t('adding', 'جارٍ الإضافة…');
      }

      var fd = new FormData(form);
      if (cfg.cartDrawerSection) fd.append('sections', cfg.cartDrawerSection);

      fetch((cfg.routes ? cfg.routes.cartAdd : '/cart/add') + '.js', {
        method: 'POST', headers: { Accept: 'application/json' }, body: fd
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || t('add_error', 'تعذّرت الإضافة للسلة')); });
          return r.json();
        })
        .then(function (data) {
          if (btn) {
            if (isIcon) {
              btn.classList.add('is-done');
              btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M5 12.5l4.5 4.5L19 7" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            } else {
              btn.textContent = btn.dataset.added || t('added', 'تمت الإضافة ✓');
            }
          }
          toast(t('added_toast', 'أضيفت القطعة إلى السلة'));
          // نستخدم HTML الدرج المُرفق أصلاً بالرد بدل طلب شبكة ثانٍ منفصل
          if (!CartDrawer.renderFromSections(data.sections)) {
            return CartDrawer.refresh().then(function () { if (CartDrawer.node()) CartDrawer.open(); });
          }
          if (CartDrawer.node()) CartDrawer.open();
        })
        .catch(function (err) { toast(err.message, 'error'); })
        .then(function () {
          setTimeout(function () {
            if (!btn) return;
            btn.disabled = false; btn.classList.remove('is-done'); btn.innerHTML = original;
          }, 1500);
        });
    });
  }

  /* ---------- عدّاد الكمية ---------- */
  function initQty() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty]');
      if (!b) return;
      var wrap = b.closest('.pf-qty');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10); if (isNaN(min)) min = 1;
      var max = parseInt(input.max, 10);
      v = b.dataset.qty === 'up' ? v + 1 : v - 1;
      if (v < min) v = min;
      if (!isNaN(max) && v > max) { v = max; toast(t('max_qty', 'وصلت للحد الأقصى المتوفر'), 'error'); }
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- درج القائمة ---------- */
  function initDrawer() {
    var drawer = $('#pf-drawer');
    var overlay = $('#pf-overlay');
    if (!drawer || !overlay) return;
    var release, lastFocus;

    function open() {
      lastFocus = document.activeElement;
      drawer.setAttribute('open', ''); drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('open', ''); lockScroll();
      release = trapFocus(drawer);
      var c = $('[data-drawer-close]', drawer);
      if (c) setTimeout(function () { c.focus({ preventScroll: true }); }, 80);
      $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    }
    function close() {
      if (!drawer.hasAttribute('open')) return;
      drawer.removeAttribute('open'); drawer.setAttribute('aria-hidden', 'true');
      overlay.removeAttribute('open');
      if (release) { release(); release = null; }
      $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      var toFocus = lastFocus;
      lastFocus = null;
      afterClose(drawer, 340, function () {
        unlockScroll();
        if (toFocus && toFocus.focus) toFocus.focus({ preventScroll: true });
      });
    }

    $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    // أكورديون القوائم الفرعية
    $$('[data-drawer-toggle]', drawer).forEach(function (b) {
      b.addEventListener('click', function () {
        var on = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', on ? 'false' : 'true');
      });
    });
  }

  /* ---------- قائمة الحساب ---------- */
  function initAccount() {
    var wrap = $('[data-account]');
    if (!wrap) return;
    var toggle = $('[data-account-toggle]', wrap);
    function close() { wrap.removeAttribute('open'); if (toggle) toggle.setAttribute('aria-expanded', 'false'); }
    function open() { wrap.setAttribute('open', ''); if (toggle) toggle.setAttribute('aria-expanded', 'true'); }
    if (toggle) toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      wrap.hasAttribute('open') ? close() : open();
    });
    document.addEventListener('click', function (e) { if (wrap.hasAttribute('open') && !wrap.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && wrap.hasAttribute('open')) close(); });
  }

  /* ---------- واتساب ---------- */
  function initWhatsapp() {
    var wrap = $('[data-wa]');
    if (!wrap) return;
    var toggle = $('[data-wa-toggle]', wrap);
    var closeBtn = $('[data-wa-close]', wrap);
    function open() { wrap.setAttribute('open', ''); if (toggle) toggle.setAttribute('aria-expanded', 'true'); }
    function close() { wrap.removeAttribute('open'); if (toggle) toggle.setAttribute('aria-expanded', 'false'); }
    if (toggle) toggle.addEventListener('click', function (e) { e.stopPropagation(); wrap.hasAttribute('open') ? close() : open(); });
    if (closeBtn) closeBtn.addEventListener('click', function (e) { e.stopPropagation(); close(); });
    document.addEventListener('click', function (e) { if (wrap.hasAttribute('open') && !wrap.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && wrap.hasAttribute('open')) close(); });
  }

  /* ---------- معرض صور المنتج ---------- */
  function initGallery() {
    var main = $('[data-pdp-main]');
    if (!main) return;
    var thumbs = $$('[data-pdp-thumb]');
    function select(t2) {
      var full = safeUrl(t2.getAttribute('data-full'));
      if (!full) return;
      main.src = full;
      var srcset = t2.getAttribute('data-srcset');
      if (srcset) main.setAttribute('srcset', srcset); else main.removeAttribute('srcset');
      var alt = t2.getAttribute('data-alt');
      if (alt !== null) main.alt = alt;
      thumbs.forEach(function (x) { x.setAttribute('aria-current', 'false'); });
      t2.setAttribute('aria-current', 'true');
    }
    thumbs.forEach(function (t2) { t2.addEventListener('click', function () { select(t2); }); });
    window.pfSelectMedia = function (mediaId) {
      var m = thumbs.filter(function (x) { return x.getAttribute('data-media-id') === String(mediaId); })[0];
      if (m) select(m);
    };
  }

  /* ---------- خيارات المنتج ---------- */
  function initVariants() {
    var root = $('[data-variants]');
    if (!root) return;
    var holder = $('[data-variants-json]');
    var data;
    try { data = JSON.parse(holder.textContent); } catch (err) { return; }
    if (!data || !data.length) return;

    var idInput = $('[data-variant-id]', root);
    var priceEl = $('[data-variant-price]');
    var btn     = $('[data-add-btn]', root);
    var skuEl   = $('[data-variant-sku]');
    var stockEl = $('[data-variant-stock]');
    var selects = $$('[data-option]', root);

    function update() {
      var chosen = selects.map(function (s) { return s.value; });
      var v = null;
      for (var i = 0; i < data.length; i++) {
        var ok = true;
        for (var j = 0; j < chosen.length; j++) { if (data[i].options[j] !== chosen[j]) { ok = false; break; } }
        if (ok) { v = data[i]; break; }
      }
      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = btn.dataset.unavailable || t('unavailable', 'غير متاح'); }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl && v.price_html) priceEl.innerHTML = v.price_html;   // مصدره Liquid على الخادم
      if (skuEl) { skuEl.textContent = v.sku || ''; skuEl.parentElement.hidden = !v.sku; }
      if (stockEl) {
        stockEl.innerHTML = '';
        var dot = document.createElement('span');
        dot.className = 'pf-dot' + (v.available ? '' : ' pf-dot--out');
        var tx = document.createElement('span');
        tx.textContent = v.available ? t('in_stock', 'متوفر') : t('out_of_stock', 'غير متوفر');
        stockEl.appendChild(dot); stockEl.appendChild(tx);
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? (btn.dataset.label || t('add_to_cart', 'أضف إلى السلة')) : (btn.dataset.sold || t('sold_out', 'نفدت الكمية'));
      }
      if (v.media_id && window.pfSelectMedia) window.pfSelectMedia(v.media_id);
      // تحديث الرابط دون إعادة تحميل — يسهّل مشاركة الخيار المحدد
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
      var sb = $('[data-stickybuy-price]');
      if (sb && v.price_html) sb.innerHTML = v.price_html;
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
  }

  /* ---------- شريط الشراء اللاصق ---------- */
  function initStickyBuy() {
    var bar = $('[data-stickybuy]');
    var anchor = $('[data-add-btn]');
    if (!bar || !anchor) return;
    document.body.classList.add('has-stickybuy');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle('is-on', !en.isIntersecting); });
    }, { rootMargin: '0px 0px -60px 0px' });
    io.observe(anchor);
    var go = $('[data-stickybuy-add]', bar);
    if (go) go.addEventListener('click', function () {
      var form = anchor.closest('form');
      if (form) form.requestSubmit ? form.requestSubmit(anchor) : anchor.click();
    });
  }

  /* ---------- كاروسيل العروض ---------- */
  function initOffers() {
    $$('.pf-offers').forEach(function (sec) {
      var track = sec.querySelector('[data-offers-track]');
      var prev = sec.querySelector('[data-offers-prev]');
      var next = sec.querySelector('[data-offers-next]');
      if (!track) return;

      function step() {
        var card = track.querySelector('.pf-offer');
        var w = card ? card.getBoundingClientRect().width + 18 : 320;
        return w * (window.innerWidth < 750 ? 1 : 2);
      }
      // اتجاه التمرير يُحسب من اتجاه الصفحة بدل افتراضه
      var rtl = getComputedStyle(track).direction === 'rtl';
      function scroll(dir) { track.scrollBy({ left: (rtl ? -dir : dir) * step(), behavior: 'smooth' }); }
      if (next) next.addEventListener('click', function () { scroll(1); });
      if (prev) prev.addEventListener('click', function () { scroll(-1); });

      function syncArrows() {
        var max = track.scrollWidth - track.clientWidth - 2;
        var pos = Math.abs(track.scrollLeft);
        if (prev) prev.disabled = pos <= 2;
        if (next) next.disabled = pos >= max;
      }
      track.addEventListener('scroll', syncArrows, { passive: true });
      window.addEventListener('resize', syncArrows);
      syncArrows();
    });
  }

  /* ---------- البحث المنبثق ---------- */
  function initSearch() {
    var root = $('#pf-search');
    var overlay = $('#pf-search-overlay');
    if (!root || !overlay) return;

    var input   = $('[data-search-input]', root);
    var results = $('[data-search-results]', root);
    var spin    = $('[data-search-spin]', root);
    var hintHTML = results ? results.innerHTML : '';
    var release, lastFocus;

    var BASE       = root.getAttribute('data-predictive-url') || '/search/suggest';
    var SEARCH_URL = root.getAttribute('data-search-url') || '/search';
    var MONEY_FMT  = root.getAttribute('data-money-format') || '{{amount}}';
    var T_VIEWALL  = root.getAttribute('data-i18n-viewall') || 'عرض كل النتائج';
    var T_NORESULT = root.getAttribute('data-i18n-noresults') || 'لا توجد نتائج مطابقة.';

    var MIN = 2, DEBOUNCE = 240, timer = null, controller = null;

    function formatMoney(price) {
      var cents;
      if (typeof price === 'number') cents = price;
      else {
        var s = String(price == null ? '' : price).trim();
        if (s.indexOf('.') > -1 || s.indexOf(',') > -1) cents = Math.round(parseFloat(s.replace(',', '.')) * 100);
        else cents = parseInt(s, 10) || 0;
      }
      var value = cents / 100;
      function num(v, dec, sep) {
        var n = v.toFixed(dec), parts = n.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return dec ? parts.join(sep || '.') : parts[0];
      }
      return MONEY_FMT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
        switch (key) {
          case 'amount_no_decimals': return num(value, 0);
          case 'amount_with_comma_separator': return num(value, 2, ',');
          case 'amount_no_decimals_with_comma_separator': return num(value, 0);
          default: return num(value, 2);
        }
      }).replace(/<[^>]*>/g, '');
    }

    function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }

    function skeleton() {
      if (!results) return;
      results.innerHTML = '';
      for (var i = 0; i < 4; i++) {
        var row = el('div', 'pf-skel');
        var a = el('span', 'pf-skel__b'); a.style.cssText = 'width:58px;height:58px;flex:none;border-radius:10px';
        var b = el('span'); b.style.cssText = 'flex:1;display:flex;flex-direction:column;gap:7px';
        var b1 = el('span', 'pf-skel__b'); b1.style.cssText = 'height:12px;width:60%';
        var b2 = el('span', 'pf-skel__b'); b2.style.cssText = 'height:12px;width:35%';
        b.appendChild(b1); b.appendChild(b2);
        row.appendChild(a); row.appendChild(b);
        results.appendChild(row);
      }
    }

    /* بناء النتائج بالكامل عبر DOM API — لا innerHTML لأي قيمة قادمة من الشبكة */
    function render(products, term) {
      if (!results) return;
      results.innerHTML = '';
      if (!products || !products.length) {
        var p = el('p', 'pf-search__hint'); p.textContent = T_NORESULT;
        results.appendChild(p);
        return;
      }
      var ul = el('ul', 'pf-psearch__list');
      ul.setAttribute('role', 'listbox');
      products.forEach(function (pr) {
        var li = el('li'); li.setAttribute('role', 'option');
        var a = el('a', 'pf-psearch__item');
        a.href = safeUrl(pr.url) || '#';

        var thumb = el('span', 'pf-psearch__thumb');
        var imgUrl = safeUrl((pr.featured_image && pr.featured_image.url) ? pr.featured_image.url : (pr.image || ''));
        if (imgUrl) {
          var img = el('img');
          img.src = imgUrl; img.width = 58; img.height = 58; img.loading = 'lazy';
          img.alt = pr.title || '';
          thumb.appendChild(img);
        } else {
          var ph = el('span', 'pf-psearch__ph');
          ph.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M4 7l8-4 8 4v10l-8 4-8-4V7z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';
          thumb.appendChild(ph);
        }

        var meta = el('span', 'pf-psearch__meta');
        if (pr.vendor) { var vn = el('span', 'pf-psearch__vendor'); vn.textContent = pr.vendor; meta.appendChild(vn); }
        var ti = el('span', 'pf-psearch__title'); ti.textContent = pr.title || ''; meta.appendChild(ti);
        var rowp = el('span', 'pf-psearch__row');
        var prc = el('span', 'pf-psearch__price');
        if (pr.price != null && pr.price !== '') prc.textContent = formatMoney(pr.price);
        rowp.appendChild(prc);
        if (pr.sku) { var sk = el('span', 'pf-psearch__sku'); sk.textContent = pr.sku; rowp.appendChild(sk); }
        meta.appendChild(rowp);

        a.appendChild(thumb); a.appendChild(meta);
        li.appendChild(a); ul.appendChild(li);
      });
      results.appendChild(ul);

      var all = el('a', 'pf-psearch__all');
      all.href = SEARCH_URL + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(term);
      var sp = el('span'); sp.textContent = T_VIEWALL;
      all.appendChild(sp);
      var arrow = el('span');
      arrow.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      all.appendChild(arrow);
      results.appendChild(all);
    }

    function open() {
      var drawer = $('#pf-drawer'), dov = $('#pf-overlay');
      if (drawer) { drawer.removeAttribute('open'); drawer.setAttribute('aria-hidden', 'true'); }
      if (dov) dov.removeAttribute('open');
      lastFocus = document.activeElement;
      root.setAttribute('open', ''); root.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('open', ''); lockScroll();
      release = trapFocus(root);
      $$('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      setTimeout(function () { if (input) input.focus({ preventScroll: true }); }, 70);
      if (input && input.value.trim().length >= MIN) run(input.value.trim());
    }

    function close() {
      if (!root.hasAttribute('open')) return;
      root.removeAttribute('open'); root.setAttribute('aria-hidden', 'true');
      overlay.removeAttribute('open');
      if (release) { release(); release = null; }
      $$('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (spin) spin.classList.remove('is-on');
      var toFocus = lastFocus;
      lastFocus = null;
      afterClose(root, 360, function () {
        unlockScroll();
        if (toFocus && toFocus.focus) toFocus.focus({ preventScroll: true });
      });
    }

    function reset() { if (results) results.innerHTML = hintHTML; if (spin) spin.classList.remove('is-on'); }

    /* تطبيع: أرقام عربية/فارسية → لاتينية، وإزالة الشرطات (أرقام القطع مخزّنة بدونها) */
    function normalizeTerm(x) {
      if (!x) return '';
      x = String(x)
        .replace(/[\u0660-\u0669]/g, function (d) { return d.charCodeAt(0) - 0x0660; })
        .replace(/[\u06F0-\u06F9]/g, function (d) { return d.charCodeAt(0) - 0x06F0; })
        .replace(/[-\u2010-\u2015_]/g, '')
        .replace(/[\u0623\u0625\u0622]/g, '\u0627')   // أ إ آ → ا
        .replace(/\u0649/g, '\u064A')                 // ى → ي
        .replace(/\u0629/g, '\u0647');                // ة → ه
      return x.trim();
    }

    function run(term) {
      if (controller) controller.abort();
      controller = new AbortController();
      if (spin) spin.classList.add('is-on');
      skeleton();
      var q = normalizeTerm(term);

      function buildUrl(base) {
        return base + '.json?q=' + encodeURIComponent(q)
          + '&resources[type]=product&resources[limit]=8'
          + '&resources[options][unavailable_products]=last'
          + '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor';
      }
      function handleData(data) {
        if (spin) spin.classList.remove('is-on');
        var products = data && data.resources && data.resources.results && data.resources.results.products;
        render(products || [], q);
      }

      /* أولًا: نسخة القسم المرسومة بـLiquid (sections/predictive-search) — تعرض شارة «طلب خاص» من الحقل المخصص.
         لو تعذّرت لأي سبب نرجع لمسار JSON الأصلي كما هو. */
      var sectionUrl = BASE + '?q=' + encodeURIComponent(q)
        + '&section_id=predictive-search'
        + '&resources[type]=product&resources[limit]=8'
        + '&resources[options][unavailable_products]=last'
        + '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor';
      var signal = controller.signal;

      function viaJson() {
        return fetch(buildUrl(BASE), { signal: signal, headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('bad'); return r.json(); })
          .then(handleData);
      }

      fetch(sectionUrl, { signal: signal, headers: { Accept: 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error('bad-section'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var box = doc.querySelector('.shopify-section') || doc.body;
          if (!box || !box.querySelector('.pf-psearch__list, .pf-psearch__empty')) throw new Error('bad-section');
          if (spin) spin.classList.remove('is-on');
          if (results) results.innerHTML = box.innerHTML;   // HTML صادر من قالب المتجر نفسه (مهرّب في Liquid)
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') throw err;
          return viaJson();
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          fetch(buildUrl('/search/suggest'), { headers: { Accept: 'application/json' } })
            .then(function (r) { if (!r.ok) throw new Error('bad2'); return r.json(); })
            .then(handleData)
            .catch(function (e2) {
              if (e2 && e2.name === 'AbortError') return;
              if (spin) spin.classList.remove('is-on');
              reset();
            });
        });
    }

    if (input) {
      input.addEventListener('input', function () {
        var term = input.value.trim();
        clearTimeout(timer);
        if (term.length < MIN) { reset(); return; }
        timer = setTimeout(function () { run(term); }, DEBOUNCE);
      });
    }

    // تطبيع كلمة البحث في أي نموذج بحث قبل الإرسال
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || f.tagName !== 'FORM') return;
      var action = f.getAttribute('action') || '';
      if (action.indexOf('/search') === -1) return;
      var qi = f.querySelector('input[name="q"]');
      if (!qi) return;
      var norm = normalizeTerm(qi.value);
      if (norm !== (qi.value || '').trim()) qi.value = norm;
    }, true);

    $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-search-close]', root).forEach(function (b) { b.addEventListener('click', close); });
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.hasAttribute('open')) close(); });
  }

  /* ---------- فلاتر المجموعة ---------- */
  function initFacets() {
    var panel = $('[data-facets]');
    var toggle = $('[data-facets-toggle]');
    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var on = panel.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }
    var form = $('[data-facet-form]');
    if (!form) return;
    var timer;
    form.addEventListener('change', function (e) {
      if (e.target.type === 'text' || e.target.type === 'number') return;
      clearTimeout(timer);
      timer = setTimeout(function () { form.submit(); }, 120);
    });
  }

  /* ---------- ظهور العناصر عند التمرير ---------- */
  function initReveal() {
    var els = $$('[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el2) { el2.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -20px 0px' });
    els.forEach(function (el2) { io.observe(el2); });
  }

  /* ---------- ظل الهيدر + زر العودة للأعلى ---------- */
  function initScrollUI() {
    var header = $('.pf-header');
    var top = $('[data-backtotop]');
    function update() {
      var y = window.scrollY;
      if (header) header.classList.toggle('is-scrolled', y > 8);
      if (top) top.classList.toggle('is-on', y > 700);
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    if (top) top.addEventListener('click', function () {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  /* ---------- عدّاد الأرقام ---------- */
  function initCounters() {
    var els = $$('[data-counter]');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function animate(el2) {
      var target = parseFloat(el2.getAttribute('data-counter')) || 0;
      if (reduce) { el2.textContent = target.toLocaleString('en-US'); return; }
      var start = null, duration = 1400;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el2.textContent = Math.floor(eased * target).toLocaleString('en-US');
        if (p < 1) window.requestAnimationFrame(step); else el2.textContent = target.toLocaleString('en-US');
      }
      window.requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animate); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { animate(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (el2) { io.observe(el2); });
  }

  function boot() {
    initDrawer(); initCartDrawer(); initAddToCart(); initCartLines(); initAccount();
    initWhatsapp(); initOffers(); initQty(); initGallery(); initVariants(); initStickyBuy();
    initSearch(); initFacets(); initReveal(); initScrollUI(); initCounters();
    getCart().then(function (c) { setCartCount(c.item_count); }).catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // إعادة التهيئة داخل محرّر الثيم
  document.addEventListener('shopify:section:load', function () {
    initOffers(); initReveal(); initCounters(); initGallery(); initVariants(); initStickyBuy(); initCartDrawer();
  });
})();
